export default __webpack_public_path__ + "static/media/icon-user-settings.730335f3.svg";